import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

const activeRowClass = "active-row";

export default class extends Controller {
  static targets = [
    "grid",
    "nextButton",
    "teamIdInput",
    "row",
    "assetLogos",
    "teamBoards",
    "searchBtn",
    "resetBtn",
    "searchTextInput",
    "addLogoRequestBtn",
  ];

  connect() {
    this.params = JSON.parse(this.data.get("params"));

    if (this.params.limitedSearch) {
      this.searchBtnTarget.disabled = true;
      this.resetBtnTarget.classList.add("disabled");

      this.searchTextInputTarget.addEventListener("input", (e) => {
        const disabled = e.target.value.length < 3;

        this.searchBtnTarget.disabled = disabled;
        this.resetBtnTarget.classList.toggle("disabled", disabled);
      });
    }

    this.frameLoaded();
  }

  async frameLoaded() {
    let activeRow;

    if (this.params.autoselectFirst) {
      activeRow = this.rowTargets
        .find(
          (row) =>
            row.getAttribute(`data-${this.identifier}-status-param`) == "active",
        );

      activeRow?.click()
    }

    if (!activeRow) {
      this.selectedRow = null;
      this.teamId = null;

      if (this.hasNextButtonTarget && this.nextButtonTarget.dataset.leadsNewPage === "true") {
        this.nextButtonTarget.disabled = true;
      }
      if (this.hasAddLogoRequestBtnTarget) {
        this.addLogoRequestBtnTarget.disabled = true;
      }

      if (this.hasAssetLogosTarget) {
        $(this.assetLogosTarget).empty();
      }

      if (this.hasTeamBoardsTarget) {
        $(this.teamBoardsTarget).reload(
          `/orders/team_presentation_boards`,
        );
      }
    }
  }

  rowClick({ currentTarget, params }) {
    if (this.hasNextButtonTarget) {
      if (this.nextButtonTarget.dataset.leadsNewPage === "true") {
        this.nextButtonTarget.disabled = false;
      } else {
        this.nextButtonTarget.disabled = params.status != "active";
      }
    }
    this.teamId = params.id;

    this.selectedRow?.classList.remove(activeRowClass);
    this.selectedRow = currentTarget;
    this.selectedRow.classList.add(activeRowClass);

    if (this.hasAddLogoRequestBtnTarget) {
      this.addLogoRequestBtnTarget.disabled = false;
    }

    if (this.hasAssetLogosTarget) {
      let status =
      $("select[name=destination]").val() || $.url().qs("as") || "active";
      $(this.assetLogosTarget).reload(
        `/asset_groups/small_logos?as=${status}&organization_id=${params.id}`,
      );
    }

    if (this.hasTeamBoardsTarget) {
      $(this.teamBoardsTarget).reload(
        `/orders/team_presentation_boards?team_id=${params.id}`,
      );
    }
  }

  editClick({ params: { url } }) {
    Turbo.visit(url.replace("id", this.teamId));
  }

  assignClick(event) {
    const url = event.currentTarget.dataset.teamGridUrlParam;
    const form = document.createElement("form");

    form.method = "POST";
    form.action = url;

    const methodInput = document.createElement("input");
    methodInput.type = "hidden";
    methodInput.name = "_method";
    methodInput.value = "patch";

    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = document.querySelector("meta[name='csrf-param']").content;
    csrfInput.value = document.querySelector("meta[name='csrf-token']").content;

    const teamIdInput = document.createElement("input");
    teamIdInput.type = "hidden";
    teamIdInput.name = "team_id";
    teamIdInput.value = this.teamId;

    form.appendChild(methodInput);
    form.appendChild(csrfInput);
    form.appendChild(teamIdInput);
    document.body.appendChild(form);

    form.requestSubmit();
  }

  nextClick({ params: { url } }) {
    Turbo.visit(`${url}?team_id=${this.teamId}`);
  }

  addLogoRequestClick() {
    // second case is a workaround for player grid
    const ownerId = this.selectedRow?.dataset.teamGridIdParam ?? $('.active-row').data('team');

    SideDialog.load(
      `/asset_groups/new?owner_type=Organization&owner_id=${ownerId}`,
    );
  }
}

